import { render, staticRenderFns } from "./Partneri.vue?vue&type=template&id=1bac7368&scoped=true&"
import script from "./Partneri.vue?vue&type=script&lang=js&"
export * from "./Partneri.vue?vue&type=script&lang=js&"
import style0 from "./Partneri.vue?vue&type=style&index=0&id=1bac7368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bac7368",
  null
  
)

export default component.exports